module.exports = __webpack_public_path__ + "static/broadcaster_sec3_2_2-fcc4da5e1beb4e306f8624b436a000fb.png";